import { Component } from '@angular/core';
import { MasterRepo } from './../common/repositories/masterRepo.service';
import { Routes } from '@angular/router';

import { BaMenuService } from '../theme';
import { PAGES_MENU } from './pages.menu';
import { var1 } from './login/login.component';
import { GlobalState } from '../global.state';

@Component({
  selector: 'pages',
  template: `
    <ba-sidebar></ba-sidebar>
    <ba-page-top></ba-page-top>
    <div class="al-main">
      <div class="al-content">
        <ba-content-top></ba-content-top>
        <router-outlet></router-outlet>
      </div>
    </div>
    <footer class="al-footer clearfix" style="padding-bottom: 0%;">
      <!-- <div class="al-footer-right" style="padding-bottom: 0%;">
        Created with <i class="ion-heart"></i>
      </div> -->
      <div class="al-footer-main clearfix">
        <div class="al-copy">
          &copy; <a href="http://himshang.com.np/">IMS Software</a>
          {{ currentYear }}
        </div>
        <ul class="al-share clearfix">
          <li><i class="socicon socicon-facebook"></i></li>
          <!--<li><i class="socicon socicon-twitter"></i></li>
          <li><i class="socicon socicon-google"></i></li>
          <li><i class="socicon socicon-github"></i></li>-->
        </ul>
      </div>
    </footer>
    <ba-back-top position="200"></ba-back-top>
  `,
  styleUrls: ['./Style.css', '../theme/components/baSidebar/baSidebar.scss'],
})
export class Pages {
  currentYear: string = '';
  public isMenuCollapsed: boolean = false;
  constructor(
    private masterRepService: MasterRepo,
    private _menuService: BaMenuService,
    private _state: GlobalState
  ) {}

  ngOnInit() {
    this._menuService.updateMenuByRoutes(<Routes>PAGES_MENU);
    this._state.subscribe('menu.isCollapsed', (value: any) => {
      this.isMenuCollapsed = value['menu.isCollapsed'];
      //this.isMenuCollapsed = isCollapsed;
      console.log({
        pagesubscriptionReceived: 'menu.iscollapsed',
        value: value,
        isMenuCollapsed: value['menu.isCollapsed'],
      });
    });
    // this.masterRepService.getCurrentDate().subscribe(date => { this.currentYear= date.Date.substring(0, 4)});
  }
}
